import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { MaterialModule } from '../material/material.module';
import { PersonasService } from '../../providers/personas.service';
import { ProspectoService } from '../../providers/prospecto.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MAT_DATE_LOCALE } from '@angular/material';
import { DashboardService } from '../../providers/dashboard.service';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPermissionsModule.forChild(),
    MaterialModule
  ],
  exports: [
    DashboardComponent
  ],
  providers: [
    PersonasService,
    ProspectoService,
    DatePipe,
    DashboardService,
    { provide: MAT_DATE_LOCALE, useValue: 'es' },
  ]
})
export class DashboardModule { }
